import { COLUMN_KEYS, COLUMN_LABELS, FILTER_KEYS } from "constants/table";

export const STATUS_COLOR_MAP = {
  Validating: "orange",
  Preprocessing: "magenta",
  Inspecting: "blue",
  Processing: "blue",
  Postprocessing: "purple",
  Completed: "green",
};

export const FIELD_KEYS = {
  ...COLUMN_KEYS,
  COMPLETED_DATE_TIME: "completed_date_time",
  COMPLETED_UNIT_COUNT: "completed_unit_count",
  GOOD_UNIT_COUNT: "good_unit_count",
  PRODUCT: "product",
  REF_NO: "ref_no",
  REJECTED_UNIT_COUNT: "rejected_unit_count",
  START_DATE_TIME: "start_date_time",
  STATUS: "status",
  YIELD: "yield",
  MACHINE: "machine",
  OPERATOR: "operator",
};

export const FIELD_LABELS = {
  ...COLUMN_LABELS,
  [FIELD_KEYS.COMPLETED_DATE_TIME]: "Completed Date Time",
  [FIELD_KEYS.COMPLETED_UNIT_COUNT]: "Completed Unit Count",
  [FIELD_KEYS.GOOD_UNIT_COUNT]: "Good Unit Count",
  [FIELD_KEYS.PRODUCT]: "Product",
  [FIELD_KEYS.REF_NO]: "Ref No",
  [FIELD_KEYS.REJECTED_UNIT_COUNT]: "Rejected Unit Count",
  [FIELD_KEYS.START_DATE_TIME]: "Start Date Time",
  [FIELD_KEYS.STATUS]: "Status",
  [FIELD_KEYS.YIELD]: "Yield",
  [FIELD_KEYS.MACHINE]: "Machine",
  [FIELD_KEYS.OPERATOR]: "Operator",
};

export const FIELD_ORDERS = [
  FIELD_KEYS.NO,
  FIELD_KEYS.PRODUCT,
  FIELD_KEYS.REF_NO,
  FIELD_KEYS.START_DATE_TIME,
  FIELD_KEYS.COMPLETED_DATE_TIME,
  FIELD_KEYS.STATUS,
  FIELD_KEYS.YIELD,
  FIELD_KEYS.GOOD_UNIT_COUNT,
  FIELD_KEYS.REJECTED_UNIT_COUNT,
  FIELD_KEYS.COMPLETED_UNIT_COUNT,
  FIELD_KEYS.ACTION,
  FIELD_KEYS.MACHINE,
  FIELD_KEYS.OPERATOR,
];

export const TABLE_FIELDS = [
  FIELD_KEYS.ACTION,
  FIELD_KEYS.NO,
  FIELD_KEYS.PRODUCT,
  FIELD_KEYS.REF_NO,
  FIELD_KEYS.START_DATE_TIME,
  FIELD_KEYS.STATUS,
  FIELD_KEYS.YIELD,
];

export const TABLE_SORTABLE_FIELDS = [
  FIELD_KEYS.PRODUCT,
  FIELD_KEYS.REF_NO,
  FIELD_KEYS.START_DATE_TIME,
  FIELD_KEYS.STATUS,
  FIELD_KEYS.YIELD,
];

export const INFO_FIELDS = [
  FIELD_KEYS.COMPLETED_DATE_TIME,
  FIELD_KEYS.COMPLETED_UNIT_COUNT,
  FIELD_KEYS.GOOD_UNIT_COUNT,
  FIELD_KEYS.PRODUCT,
  FIELD_KEYS.REF_NO,
  FIELD_KEYS.REJECTED_UNIT_COUNT,
  FIELD_KEYS.START_DATE_TIME,
  FIELD_KEYS.STATUS,
  FIELD_KEYS.YIELD,
  FIELD_KEYS.MACHINE,
  FIELD_KEYS.OPERATOR,
];
